import Moment from 'bdata-sns-shared/utils/Moment';

const getTvUrl = (
    urlRoot,
    gamePk,
    gameDate
) => {
    const baseUrl = `${urlRoot}/tv/g${gamePk}`;

    if (!gameDate) {
        return baseUrl;
    }

    const moment = Moment.getMoment();
    const momentDate = moment(gameDate);
    const formattedDate = momentDate.format("YYYYMMDD");
    return `${baseUrl}${formattedDate ? `/${formattedDate}` : ''}`;
};

export default getTvUrl;
